import { calculateRem } from '@uie/javascript-style-helpers';
export var updateDialogPosition = function updateDialogPosition(props) {
  var isDialogOnTop = props.isDialogOnTop,
      customAnchorElement = props.customAnchorElement,
      customAnchorPresent = props.customAnchorPresent,
      offset = props.offset,
      size = props.size;

  if (!customAnchorPresent) {
    if (isDialogOnTop) {
      /* styles for when dialog is above anchor and no customAnchorElement */
      return "\n          bottom: ".concat(calculateRem(size === 'small' ? 27 : 30), ";\n        &::after {\n          transform: translate(-50%) rotate(225deg) !important;\n        };\n        ");
    }
    /* styles for when dialog is below anchor and no customAnchorElement */


    return "\n        top: ".concat(calculateRem(size === 'small' ? 27 : 30), ";\n        &::before {\n          top: ").concat(calculateRem(-5), ";\n          transform: translate(-50%) rotate(225deg) !important;\n        };\n      ");
  }

  if (customAnchorPresent) {
    if (isDialogOnTop) {
      /* styles for when dialog is above anchor and customAnchorElement */
      return "\n        left: ".concat(calculateRem(Math.round(customAnchorElement.getBoundingClientRect().width / 2)), ";\n          bottom: ").concat(calculateRem(customAnchorElement.getBoundingClientRect().height + 6), ";\n        ");
    }
    /* styles for when dialog is below anchor and customAnchorElement */


    return "\n      left: ".concat(calculateRem(Math.round(customAnchorElement.getBoundingClientRect().width / 2)), ";\n      top: ").concat(calculateRem(customAnchorElement.getBoundingClientRect().height + offset + 8), ";\n\n        &::before {\n          top: ").concat(calculateRem(-5), ";\n          transform: translate(-50%) rotate(225deg) !important;\n        };\n      ");
  }
};